// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-lesotho/calculator-lesotho-personal-loan/calculator-lesotho-personal-loan.component.scss
// module id = 792
// module chunks = 0